module.exports = __webpack_public_path__ + "img/banner-2.ff8686fd.png";